var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-header"},[_c('img',{staticClass:"top-logo",attrs:{"src":require("@/assets/images/common/header_welcome.png"),"alt":"app_logo","width":"60%"}})])
}]

export { render, staticRenderFns }